export enum UI {
  LANGUAGE_SELECTION,
  WELCOME,
  MAIN,
  CONFIRM_LICENCE_PLATE,
  CONFIRM_RESERVATION,
  LICENCE_PLATE_AUTH,
  TRAILER,
  CARGO_LENGTH,
  CARGO_CONTENT,
  CARGO_WEIGHT,
  CONSIGNEE,
  FROM_TO,
  CONFIRM_CONNECTION,
  DRIVERS_INFORMATION,
  DOCUMENT_INFORMATION,
  DRIVERS_INFORMATION_AND_DOCUMENT_MOBILE,
  DRIVER2_INFORMATION,
  DOCUMENT2_INFORMATION,
  DRIVER2_INFORMATION_AND_DOCUMENT_MOBILE,
  MORE_THAN_ONE_PASSENGER,
  SUMMARY,
  CONFIRM_RESERVATION_INFO,
  CHECKIN_DONE,
  ERROR,
  OUT_OF_SERVICE,
  ALREADY_CHECKED_IN,
  PRINT_SWB,
  DANGEROUS_GOODS,
  DOWNLOAD_SWB,
}
